// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1wCpQ","validationTips":"StatementDescriptor_validationTips__2uk9V"};